import { render } from "./MenuItemsCreate.vue?vue&type=template&id=127f0532"
import script from "./MenuItemsCreate.vue?vue&type=script&lang=js"
export * from "./MenuItemsCreate.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__